import React from 'react';

import { Box, Breadcrumb, Heading } from '@primer/components'
import { Link } from 'react-router-dom'

import WaveHero from '../components/WaveHero'
import Challenge from '../components/Challenge/Challenge'


export default function(props) {
  return (
    <>
      <WaveHero>
        <Box className="container-lg lead text-white pt-2 pb-9 pb-md-8 pt-md-8 pl-4 pl-md-0">
          <Breadcrumb>
            <Breadcrumb.Item as={Link} to={'/features/django'} className="text-white">Home</Breadcrumb.Item>
            <Breadcrumb.Item as={Link} to={'/features/django/challenge'} className="text-white">Django challenges</Breadcrumb.Item>
            <br/>
          </Breadcrumb>
          <Heading className="mb-0 text-white" style={{ display: 'block' }}>{props.title}</Heading>
        </Box>
      </WaveHero>
      <Box className="container-lg pb-8 lead pl-4 pr-4 pr-md-0 pl-md-0 pt-4">
        <Challenge {...props} />
      </Box>
    </>
  )
}